// extracted by mini-css-extract-plugin
export default {"component":"Navbar_component__b1FXX","menu":"Navbar_menu__CdC6t","right":"Navbar_right__baaGN","leaderboard":"Navbar_leaderboard__dQcvs"};